<template>
        <Drop @drop="moveItem" class="cards-edit-box">
            <Drag v-if="task" class="board-cart-title text-word-break"
                  :transferData="{
                    fromTaskIndex: taskIndex,
                    location: location
                  }"
                  @click.native="goToTask(task)"
                  :id="'task-badge-' + task.id"
                  :style="{ backgroundColor: convertHex(task.colour_label, 40) || '#FFFFFF'}"
            >
                <span>{{ task.name }}</span>
            </Drag>
        </Drop>
</template>

<script>
import Drag from "./Drag";
import Drop from "./Drop";
import MovingPrioritiesItems from "../../mixins/MovingPrioritiesItems";

export default {
    name: "BacklogTask",
    props: {
        task: {
            type: Object,
            required: false
        },
        location: {
            type: String,
            required: true
        },
        taskIndex: {
            type: Number,
            required: true
        }
    },
    data: () => {
        return {
            showModal: false
        };
    },
    components: { Drag, Drop },
    mixins: [MovingPrioritiesItems],
    methods: {
        goToTask (task) {
            let params = { id: task.id };
            if(this.$route.params.doc_id) {
                params.doc_id = this.$route.params.doc_id;
            } else {
                let url = window.location.href;
                let urlArray = url.split('/');
                // saved in the database
                if(urlArray.length > 5 && urlArray[5] != 'task' && urlArray[5]) {
                    params.doc_id = urlArray[5];
                }
            }
            this.$router.push({ name: 'Priorities idea', params: params })
        },
        convertHex(hexCode,opacity){
            if(! hexCode) {
                return null;
            }
            let hex = hexCode.replace('#','');

            if (hex.length === 3) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }

            let r = parseInt(hex.substring(0,2), 16),
                g = parseInt(hex.substring(2,4), 16),
                b = parseInt(hex.substring(4,6), 16);

            return 'rgba('+r+','+g+','+b+','+opacity/100+')';
        },
    }
}
</script>

<style scoped>

.board-cart-title span {
    color: #16181F;
    font-size: 14px;
    font-weight: 500;
    font-family: "Fira Sans", sans-serif;
    padding: 7px 13px;
    display: block;
    height: 100%;
}

/*.cards-edit-box {*/
/*    width: 100%;*/
/*    margin-bottom: 30px;*/
/*}*/
</style>
